export class TeamsRoutesPaths {
  static teamAdmin(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/admin`;
  }

  static teamMain(teamId: string) {
    return `/${teamId}`;
  }

  static workspaceMain(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}`;
  }

  static workspaceReports(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/reports`;
  }
}
